"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  SkipLink: true
};
exports.default = exports.SkipLink = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Link = require("../Link/Link");
var _SkipLink = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SkipLink.css") : void 0);
var _SkipLink2 = require("./SkipLink.types");
Object.keys(_SkipLink2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SkipLink2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SkipLink2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-skip-link';
/** Keyboard, screen readers, switch controls
 * and other assistive technologies users use skip links to reach main content or other important
 * sections easier and faster.
 *
 *  CoreUI provides a skip link on the page to skip navigation,
 * but consumers may want to use skip links to skip sections.
 *
 * In most cases, the single skip link provided on the page by CoreUI is sufficient.
 * A very complex page with several repeated elements may necessitate additional skip links.
 * Remember, the purpose of skip navigation links
 *  is to make keyboard navigation more efficient. Adding more links increases link-clutter. Source: [WebAIM](https://webaim.org/techniques/skipnav/)
 *
 *
 *  > Currently unsupported: **Listbox** with grouping, **GridListbox** with grouping.
 * [UICOMP-9786](https://jira.concur.com/browse/UICOMP-9786) */
const SkipLink = exports.SkipLink = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const _a = addChildProps ? Object.assign(Object.assign({}, props), addChildProps(SkipLink, props)) : props,
    {
      className,
      url,
      label,
      inList
    } = _a,
    linkProps = __rest(_a, ["className", "url", "label", "inList"]);
  const classnames = _bind.default.bind(_SkipLink.default);
  return /*#__PURE__*/_react.default.createElement(_Link.Link, Object.assign({}, linkProps, {
    className: classnames(CSS_BLOCK, className, {
      [`${CSS_BLOCK}--list`]: !!inList
    }),
    href: url,
    ref: ref
  }), label);
});
SkipLink.displayName = 'SkipLink';
var _default = exports.default = SkipLink;